import React, { useEffect, useState } from 'react';
import moment from 'moment';
import styles from './DayCountAvailableForBooking.module.css';

const DayCountAvailableForBooking = props => {
  const { dateValues, intl, formId = 'form', form, values } = props;
  const { startDate, endDate } = dateValues || {};
  const hoursArray = [
    // {
    //   name: intl.formatMessage({ id: 'CustomExtendedDataField.placeholderSingleSelect' }),
    //   min: '-0',
    //   max: '-0',
    // },
    { name: '9:00 - 12:00', min: '9', max: '12' },
    { name: '12:00 - 15:00', min: '12', max: '15' },
    { name: '15:00 - 18:00', min: '15', max: '18' },
    { name: '18:00 - 21:00', min: '18', max: '21' },
  ];
  const [previousStart, setPreviousStart] = useState('9');
  const [previousEnd, setPreviousEnd] = useState('21');
  const [startDateError, setStartDateError] = useState('');
  const [endDateError, setEndDateError] = useState('');

  const handleChange = (e, dateType) => {
    const dateValue = e.target.value;
    const newStartDate = dateType === 'start' ? startDate.setHours(dateValue, 0) : startDate;
    const newEndDate = dateType === 'end' ? endDate.setHours(dateValue, 0) : endDate;

    // Validate time difference before updating the form
    const error = validateDateDifference(newStartDate, newEndDate);

    if (error) {
      // Revert to the previous selection if there is an error
      if (dateType === 'start') {
        form.change('startDateError', error);
        form.change('defaultStart', previousStart);
      } else {
        form.change('endDateError', error);
        form.change('defaultEnd', previousEnd);
      }
      return; // Exit without updating the form if there’s an error
    } else if (newEndDate < startDate) {
      form.change('startDateError', 'BookingDatesForm.requiredStartHour');
      return null;
    }

    // No error, proceed with updating the form
    if (dateType === 'start' && dateValue !== '-0') {
      setPreviousStart(dateValue); // Store the last valid start value
      form.batch(() => {
        form.change('bookingStartDate', { date: convertDate(new Date(newStartDate)) });
        form.change('bookingStartTime', newStartDate);
        form.change('startDateError', ''); // Clear any existing errors
        form.change('endDateError', '');
      });
    } else if (dateType === 'end' && dateValue !== '-0') {
      setPreviousEnd(dateValue); // Store the last valid end value
      form.batch(() => {
        setPreviousEnd(dateValue);
        form.change('bookingEndTime', newEndDate);
        form.change('bookingEndDate', { date: convertDate(new Date(newEndDate)) });
        form.change('startDateError', ''); // Clear any existing errors
        form.change('endDateError', '');
      });
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.field}>
        <label htmlFor={formId ? `${formId}.bookingStartTime` : 'bookingStartTime'}>
          {intl.formatMessage({ id: 'FieldDateAndTimeInput.startTime' })}
        </label>
        <select
          name="defaultStart"
          id={formId ? `${formId}.bookingStartTime` : 'bookingStartTime'}
          disabled={!startDate}
          onChange={e => handleChange(e, 'start')}
          value={previousStart}
        >
          {hoursArray.map(({ min, name }) => (
            <option key={min} value={min}>
              {name}
            </option>
          ))}
        </select>
        {values.startDateError && (
          <span className={styles.error_message}>
            {intl.formatMessage({ id: values.startDateError })}
          </span>
        )}
      </div>

      <div className={styles.field}>
        <label htmlFor={formId ? `${formId}.bookingEndTime` : 'bookingEndTime'}>
          {intl.formatMessage({ id: 'FieldDateAndTimeInput.endTime' })}
        </label>
        <select
          name="defaultEnd"
          id={formId ? `${formId}.bookingEndTime` : 'bookingEndTime'}
          disabled={!startDate}
          onChange={e => handleChange(e, 'end')}
          value={previousEnd}
        >
          {hoursArray.map(({ max, name }) => (
            <option key={max} value={max}>
              {name}
            </option>
          ))}
        </select>
        {values.endDateError && (
          <span className={styles.error_message}>
            {intl.formatMessage({ id: values.endDateError })}
          </span>
        )}
      </div>
    </div>
  );
};

export default DayCountAvailableForBooking;

const convertDate = originalDateString => {
  const date = moment(originalDateString, 'ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
  return date.tz('Europe/Madrid').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
};

const validateDateDifference = (startDate, endDate) => {
  // if (!startDate || !endDate) {
  //   console.log('Either startDate or endDate is undefined');
  //   return;
  // }

  const start = new Date(startDate);
  const end = new Date(endDate);
  const diffInMs = end - start;

  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
  const remainingMs = diffInMs % (1000 * 60 * 60 * 24);
  const diffInHours = Math.floor(remainingMs / (1000 * 60 * 60));

  if (diffInDays === 0 && diffInHours <= 3) {
    return 'BookingDatesForm.requiredStartHour';
  }
  return undefined;
};
